import SalesForceInfosModel from './sales-force-infos.model';

export default class GroupedSalesForceInfosModel {
  agrupador!: string;

  items!: Array<SalesForceInfosModel>;
}
